import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="w-full py-16 px-6 md:px-12 bg-gray-50 border-t border-gray-200/50 transition-colors" data-id="element-21">
      <div className="max-w-7xl mx-auto" data-id="element-22">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-23">
          <div className="mb-8 md:mb-0" data-id="element-24">
            <Link to="/" className="flex items-center" data-id="element-25">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9QqUfvRDGwG7W9qysjtvXP/RC-Logo_01-PositiveRGB.png" alt="Race Capital Logo" className="h-10" data-id="element-26" />
            </Link>
          </div>
          <div className="flex space-x-6" data-id="element-27">
            <a href="https://x.com/RaceCapital" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-red-600 transition-colors p-2 hover:bg-gray-100 rounded-lg" data-id="element-28">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-29">
                <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-30"></path>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/racecapital/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-red-600 transition-colors p-2 hover:bg-gray-100 rounded-lg" data-id="element-31">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-32">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-33"></path>
                <rect x="2" y="9" width="4" height="12" data-id="element-34"></rect>
                <circle cx="4" cy="4" r="2" data-id="element-35"></circle>
              </svg>
            </a>
            <a href="mailto:deals@race.capital" className="text-gray-600 hover:text-red-600 transition-colors p-2 hover:bg-gray-100 rounded-lg" data-id="element-36">
              <MailIcon className="h-5 w-5" data-id="element-37" />
            </a>
          </div>
        </div>
        <div className="mt-12 text-center md:text-left" data-id="element-38">
          <p className="text-gray-600 text-sm transition-colors" data-id="element-39">
            © 2025 Race Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};